import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AnimatePresence, motion } from "framer-motion";

import PanelDev from 'panels/dev/PanelDev';

import PanelOverview from 'panels/home/PanelOverview';
import PanelNotifi from 'panels/cms/PanelNotifi';
import PanelLibrary from 'panels/cms/PanelLibrary';
import PanelIntern from 'panels/cms/PanelIntern';
import PanelWorkshop from 'panels/cms/PanelWorkshop';
import PanelBlogs from 'panels/cms/PanelBlogs';
import PanelNews from 'panels/cms/PanelNews';

import PanelPortal from 'panels/cms/PanelPortal';
import PanelResearch from 'panels/cms/PanelResearch';
import PanelStore from 'panels/cms/PanelStore';
import PanelStdPage from 'panels/cms/PanelStdPage';
import PanelAddPage from 'panels/cms/PanelAddPage';
import PanelStyle from 'panels/cms/PanelStyle';
import PanelHighlight from 'panels/cms/PanelHighlight';

export default function LayoutContact() {

    const [isOpen, setIsOpen] = useState(true);

    const { page } = useParams();

    const navigate = useNavigate();

    const itemVariants = {
        closed: { opacity: 0 },
        open: { opacity: 1 }
    };

    const changeNav = (link) => {
        navigate(`/home/${link}`);
        setIsOpen(true);
    }

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    useEffect(() => {
        if (page === "pageStyle") {
            setIsOpen(false);
        }
    }, [page]);

    return (
        <>
            <AnimatePresence>
                {
                    isOpen && <motion.div initial={{ width: 0 }} animate={{ width: '16rem' }} exit={{ width: 0, transition: { delay: 0.2, duration: 0.3 } }} className="w-56 lg:w-64 h-screen bg-slate-100">
                        <motion.h1 initial="closed" animate="open" exit="closed" variants={itemVariants} className="text-xl lg:text-2xl font-medium pt-4 ml-6">CMS Menu</motion.h1>
                        <motion.ul initial="closed" animate="open" exit="closed" variants={itemVariants} className="w-64 flex flex-col items-start mt-2 lg:mt-4">
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'main' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('main') }}>Overview</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'notifi' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('notifi') }}>Notification</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'workshop' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('workshop') }}>Workshop</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'intern' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('intern') }}>Intern</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'library' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('library') }}>Library</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'blogs' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('blogs') }}>Blogs</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'news' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('news') }}>News & Media</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'highlight' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('highlight') }}>Highlights</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'store' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('store') }}>Store</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'research' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('research') }}>Research</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'portal' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('portal') }}>Portal</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'spage' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('spage') }}>Standard Page</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'apage' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('apage') }}>Additional Page</li>
                        </motion.ul>
                    </motion.div>
                }
            </AnimatePresence>
            <div className='h-screen w-full'>
                {
                    (() => {
                        switch (page) {
                            case 'main':
                                return (<PanelOverview />);
                            case 'notifi':
                                return (<PanelNotifi />);
                            case 'workshop':
                                return (<PanelWorkshop />);
                            case 'intern':
                                return (<PanelIntern />);
                            case 'library':
                                return (<PanelLibrary />);
                            case 'blogs':
                                return (<PanelBlogs />);
                            case 'news':
                                return (<PanelNews />);
                            case 'highlight':
                                return (<PanelHighlight />);
                            case 'portal':
                                return (<PanelPortal />);
                            case 'research':
                                return (<PanelResearch />);
                            case 'store':
                                return (<PanelStore />);
                            case 'spage':
                                return (<PanelStdPage />);
                            case 'apage':
                                return (<PanelAddPage />);
                            case 'pageStyle':
                                return (<PanelStyle toggle={toggleMenu} />);
                            default:
                                return (<PanelDev />);
                        }
                    })()
                }
            </div>
        </>
    )
}
